<template lang="pug">
  #Home.ld
    Header(style='position: relative;z-index: 10000;')
    v-skeleton-loader.mx-auto#ld(v-if='policeCarousel' max-height='400' style='width:100%;' type='image')
    div(v-if='carousel && carousel.length > 0')
      v-flex(xs12 style='height: auto;display: flex;position:relative;')
        v-carousel(height='auto' hide-delimiters='')
          v-carousel-item(v-for='(item, i) in carousel' :key='i')
            img(:src='ruta + item.imagen' style='height:auto;width:100%;object-fit:cover;')
    div(class='features-section')
      div(class='features-grid')
        div(class='feature-card fade-up')
          div(class='feature-icon')
            img(src='@/assets/imgFerco/papel.png')
          div(class='feature-text')
            span(class='feature-title') Mayor automotriz
            span(class='feature-sub') gran variedad de stock
        div(class='feature-card fade-up')
          div(class='feature-icon')
            img(src='@/assets/imgFerco/people.png')
          div(class='feature-text')
            span(class='feature-title') Equipo comprometido
            span(class='feature-sub') con nuestros clientes
        div(class='feature-card fade-up')
          div(class='feature-icon')
            img(src='@/assets/imgFerco/camion.png')
          div(class='feature-text')
            span(class='feature-title') Entregas
            span(class='feature-sub') inmediatas y seguras
        div(class='feature-card fade-up')
          div(class='feature-icon')
            img(src='@/assets/imgFerco/tienda.png')
          div(class='feature-text')
            span(class='feature-title') Llegamos hasta
            span(class='feature-sub') cada establecimiento
    div(v-if='policeBanners' style='display: flex;justify-content: center;margin-top: 20px;margin-bottom: 50px;')
      v-flex(xs11 sm10 md10)
        v-layout(wrap style='display: flex;align-content: center;')
          v-flex(xs12 sm12 md6 class='pddr')
            v-skeleton-loader.mx-auto#ld2(style='width:100%;' type='image')
          v-flex(xs12 sm12 md6 class='pddl')
            v-skeleton-loader.mx-auto#ld2(style='width:100%;' type='image')
    div(v-if='bannersI || bannersD' style='display: flex;justify-content: center;margin-top: 20px;margin-bottom: 50px;')
      v-flex(xs11 sm10 md10)
        v-layout(wrap style='display: flex;align-content: center;')
          v-flex(xs12 sm12 md6 class='pddr')
            div(class='banner-card' v-if='bannersI')
              img(:src='ruta + bannersI.imagen' style='height:250px;width:100%;object-fit:cover;')
          v-flex(xs12 sm12 md6 class='pddl')
            div(class='banner-card' v-if='bannersD')
              img(:src='ruta + bannersD.imagen' style='height:250px;width:100%;object-fit:cover;')
    div(v-if='policeMarcas' style='display: flex;justify-content: center;margin-top: 20px;margin-bottom: 50px;')
      v-flex(xs11 sm10 md10)
        v-layout(wrap)
          v-flex(xs12)
            div(style='width: 200px;margin-bottom: 20px;')
              v-skeleton-loader.mx-auto#ld2(max-height='30' max-width='200' type='image')
          v-flex(xs12)
            carousel(:perPageCustom="[[320, 1],[480, 2], [768, 4], [1160, 6]]")
              slide(v-for='(item,i) in arraySke' style='padding-left: 5px;padding-right: 5px;')
                div.carouselMarkSke
                  v-skeleton-loader.mx-auto#ld3(style='width:100%;' type='image')
    div(v-if='marcasWeb && marcasWeb.length > 0' style='display: flex;justify-content: center;margin-top: 20px;margin-bottom: 50px;')
      v-flex(xs11 sm10 md10)
        v-layout(wrap)
          v-flex(xs12)
            h2(class='section-title') Marcas destacadas
          v-flex(xs12)
            carousel(:perPageCustom="[[320, 1],[480, 2], [768, 4], [1160, 6]]")
              slide(v-for='(item,i) in marcasWeb' style='padding-left: 8px;padding-right: 8px;')
                div(@click='irProdMarca(item)' class='brand-card')
                  div.imgCarouselDiv
                    img(:src='ruta + item.imagen' style='height:110px;width:120px;object-fit:contain;')
                  span(class='brand-name') {{item.des_color}}
    div(v-if='policeCategorias' style='background:#e8e8e8;')
      div(style='display: flex;justify-content: center;margin-top: 20px;margin-bottom: 50px;padding-top:30px;padding-bottom:30px;')
        v-flex(xs11 sm10 md10)
          v-layout(wrap)
            v-flex(xs12)
              div(style='width: 200px;margin-bottom: 20px;')
                v-skeleton-loader.mx-auto#ld2(max-height='30' max-width='200' type='image')
            v-flex(xs12)
              v-card(style='background:white;padding: 50px;')
                v-layout(wrap)
                  v-flex(xs12 sm12 md6)
                    v-skeleton-loader.mx-auto#ld4(style='100%' type='image')
                  v-flex(xs12 sm6 md3 v-for='(prod,i) in arraySkeP' v-bind:class="{ 'flexImgSke': i != 2, 'flexImgSke2': i == 2  }")
                    div(class='divImg')
                      v-skeleton-loader.mx-auto#ld3(style='width:100%;' type='image')
    div(v-if='categoriasWeb && categoriasWeb.length > 0' class='categories-section')
      div(v-for='(item,i) in categoriasWeb' :key='item._id' style='display: flex;justify-content: center;padding-top:36px;padding-bottom:24px;')
        v-flex(xs11 sm10 md10)
          v-layout(wrap)
            v-flex(xs12)
              h2(class='section-title') {{item.cat_des}}
            v-flex(xs12)
              div(class='category-block')
                v-layout(wrap)
                  v-flex(xs12 sm12 md6 style='display:flex;')
                    div(class='category-hero' @click='irProductos(item)')
                      img(:src='ruta + item.imagen' style='height:280px;width:100%;object-fit:contain;')
                      div(class='category-hero-overlay')
                        span Ver todo
                  v-flex(xs12 sm6 md3 v-for='(prod,i) in item.productos' :key='prod._id' style='padding:8px;')
                    div(@click='ir(prod._id)' class='product-card')
                      div(style='display:flex;justify-content:center;align-items:center;height:150px;overflow:hidden;')
                        img(:src='ruta + prod.imagen[0].url' style='height:140px;width:auto;object-fit:contain;')
                      div(style='display: flex;flex-direction: column;gap:3px;margin-top:8px;')
                        span(class='product-brand') {{prod.marcaN}}
                        span(class='product-name') {{prod.art_des}}
                        span(v-if='mostrarS' class='badge-stock' style='align-self:flex-start;') Existencia: {{prod.stock}}
                        span(v-if='mostrarP' class='price-tag') ${{prod.precio}}
    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import { server, port, serverImg } from '@/services/environment'
export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      arraySke: ['1', '2', '3', '4', '5', '6', '7', '8'],
      arraySkeP: ['1', '2', '3', '4', '5', '6'],
      policeCarousel: true,
      policeCategorias: true,
      policeBanners: true,
      policeMarcas: true,
      categoriasWeb: [],
      marcasWeb: [],
      carousel: [],
      bannersD: null,
      bannersI: null,
      mostrarP: false,
      mostrarS: false,
      tamanno: window.screen.width,
      ruta: serverImg
    }
  },
  created () {
    this.initialize()
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.co_cli) {
      this.mostrarP = true
    }
    if (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.stock) {
      this.mostrarS = this.$store.state.emanuelWeb.stock
    }
  },
  methods: {
    ir (item) {
      this.$router.push('/detalle/' + item)
    },
    irProdMarca (item) {
      this.$router.push({ name: 'Productos', params: { marca: item } })
    },
    irProductos (item) {
      this.$router.push({ name: 'Productos', params: { categoria: item } })
    },
    async initialize () {
      const cli = (this.$store.state.emanuelWeb && this.$store.state.emanuelWeb.co_precio) ? this.$store.state.emanuelWeb.co_precio.trim() : null
      await Api.get('categoriaWeb/withProduct?codigo=' + cli).then(res => {
        this.categoriasWeb = res.data
        this.policeCategorias = false
      })
      await Api.get('marcas/withImg').then(res => {
        this.marcasWeb = res.data
        this.policeMarcas = false
      })
      await Api.get('carousel').then(res => {
        this.carousel = res.data
        this.policeCarousel = false
      })
      await Api.get('banners').then(res => {
        console.log(res.data)
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i]
          if (el.posicion == 'Izquierda') this.bannersI = el
          if (el.posicion == 'Derecha') this.bannersD = el
        }
        this.policeBanners = false
      })
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/home.scss";
</style>
